module.exports = __webpack_public_path__ + "static/media/notfound.cc878632.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/notfound.png
// module id = 457
// module chunks = 5